/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var GeographicAreaType;

(function (GeographicAreaType) {
  GeographicAreaType["UK_ONLY"] = "uk-only";
  GeographicAreaType["US_ONLY"] = "us-only";
  GeographicAreaType["CERTAIN_COUNTRIES"] = "certain-countries";
  GeographicAreaType["EUROPEAN_UNION"] = "european-union";
  GeographicAreaType["EU_EXCEPT_CERTAIN_COUNTRIES"] = "eu-except-certain-countries";
  GeographicAreaType["WORLDWIDE_EXCEPT_CERTAIN_COUNTRIES"] = "worldwide-except-certain-countries";
  GeographicAreaType["WORLDWIDE"] = "worldwide";
})(GeographicAreaType || (GeographicAreaType = {}));